export const FormBuilderComponentTypes = {
    AdditionalNotes: 'additionalNotes',
    AppointmentBooking: 'appointmentBooking',
    Payment: 'payment',
    StripePayment: 'stripePayment',
    Attachment: 'attachment',
    Image: 'image',
    CheckboxQuestion: 'checkboxQuestion',
    Dropdown: 'dropdown',
    MultipleChoice: 'multipleChoice',
    Signature: 'signature',
    SingleChoice: 'singleChoice',
    SingleText: 'singleText',
    TextBox: 'textBox',
    NumericInputBox: 'numericInputBox',
    MultiLineInput: 'multiLineInput',
    TickBoxGrid: 'tickBoxGrid',
    MultipleChoiceGrid: 'multipleChoiceGrid',
    LinearScale: 'linearScale',
    OfferStatusChoice: 'offerStatusChoice',
    FileUploader: 'fileUploader',
    DateTime: 'dateTime',
    Date: 'date',
    LookupDropdown: 'lookupDropdown',
    Address: 'address',
    IntakeChoice: 'intakeChoice',
    BoarderStatusChoice: 'boarderStatusChoice',
    QuestionGrid: 'questionGrid',
    Separator: 'separator',
    UPN: 'upn',
    PreviousSchoolName: 'previousSchoolName',
    PreviousSchoolEmail: 'previousSchoolEmail',
    EmployeeSelect: 'employeeSelect',
    StudentPhoto: 'studentPhoto',
    Calculation: 'calculation',
};

export const ComponentCategory = Object.freeze({
    TEXT: 'Text & Notes',
    CHOICE: 'Choice & Selection',
    DATETIME: 'Date / Time',
    MEDIA: 'Files & Media',
    LAYOUT: 'Layout',
    OTHER: 'Other',
    STUDENT_PROFILE_ATTRIBUTES: 'Student Profile Attributes',
});

export const FORM_BUILDER_COMPONENTS = [
    {type: FormBuilderComponentTypes.AdditionalNotes, description: 'Notes', category: ComponentCategory.TEXT},
    {type: FormBuilderComponentTypes.SingleText, description: 'Single Line', category: ComponentCategory.TEXT},
    {type: FormBuilderComponentTypes.TextBox, description: 'Textbox', category: ComponentCategory.TEXT},
    {type: FormBuilderComponentTypes.NumericInputBox, description: 'Numeric Input', category: ComponentCategory.TEXT },
    {type: FormBuilderComponentTypes.MultiLineInput, description: 'Multiple Inputs', category: ComponentCategory.TEXT},
    {type: FormBuilderComponentTypes.CheckboxQuestion, description: 'Checkbox', category: ComponentCategory.CHOICE},
    {type: FormBuilderComponentTypes.Dropdown, description: 'Dropdown', category: ComponentCategory.CHOICE},
    {
        type: FormBuilderComponentTypes.LookupDropdown,
        description: 'Lookup Dropdown',
        category: ComponentCategory.CHOICE
    },
    {
        type: FormBuilderComponentTypes.MultipleChoice,
        description: 'Multiple Choice',
        category: ComponentCategory.CHOICE
    },
    {type: FormBuilderComponentTypes.SingleChoice, description: 'Single Choice', category: ComponentCategory.CHOICE},
    {type: FormBuilderComponentTypes.TickBoxGrid, description: 'Tick Box Grid', category: ComponentCategory.CHOICE},
    {
        type: FormBuilderComponentTypes.MultipleChoiceGrid,
        description: 'Multiple Choice Grid',
        category: ComponentCategory.CHOICE
    },
    {type: FormBuilderComponentTypes.LinearScale, description: 'Linear Scale', category: ComponentCategory.CHOICE},
    {type: FormBuilderComponentTypes.IntakeChoice, description: 'Intake Choice', category: ComponentCategory.CHOICE},
    {type: FormBuilderComponentTypes.QuestionGrid, description: 'Question Grid', category: ComponentCategory.TEXT},
    {type: FormBuilderComponentTypes.Separator, description: 'Separator Line', category: ComponentCategory.LAYOUT},
    {type: FormBuilderComponentTypes.DateTime, description: 'Date and Time', category: ComponentCategory.DATETIME},
    {type: FormBuilderComponentTypes.Date, description: 'Date', category: ComponentCategory.DATETIME},
    {type: FormBuilderComponentTypes.Attachment, description: 'Attachment', category: ComponentCategory.MEDIA},
    {type: FormBuilderComponentTypes.Image, description: 'Image', category: ComponentCategory.MEDIA},
    {type: FormBuilderComponentTypes.FileUploader, description: 'File Uploader', category: ComponentCategory.MEDIA},
    {type: FormBuilderComponentTypes.Signature, description: 'Signature', category: ComponentCategory.MEDIA},
    {
        type: FormBuilderComponentTypes.AppointmentBooking,
        description: 'Appointment Booking',
        category: ComponentCategory.OTHER
    },
    {type: FormBuilderComponentTypes.Payment, description: 'Payment', category: ComponentCategory.OTHER},
    {
        // Takes the payment inside Admicity and records it against the response, as opposed to
        // Payment above, which sends the payer out to a link the school pastes in.
        type: FormBuilderComponentTypes.StripePayment,
        description: 'Stripe Payment',
        category: ComponentCategory.OTHER
    },
    {
        type: FormBuilderComponentTypes.OfferStatusChoice,
        description: 'Application Status Choice',
        category: ComponentCategory.OTHER
    },
    {type: FormBuilderComponentTypes.Address, description: 'Address', category: ComponentCategory.OTHER},
    {type: FormBuilderComponentTypes.Calculation, description: 'Calculation', category: ComponentCategory.OTHER},
    {
        type: FormBuilderComponentTypes.BoarderStatusChoice,
        description: 'Boarder Status Choice',
        category: ComponentCategory.CHOICE
    },
    {
        type: FormBuilderComponentTypes.UPN,
        description: 'UPN',
        category: ComponentCategory.STUDENT_PROFILE_ATTRIBUTES
    },
    {
        type: FormBuilderComponentTypes.PreviousSchoolName,
        description: 'Previous School Name',
        category: ComponentCategory.STUDENT_PROFILE_ATTRIBUTES
    },
    {
        type: FormBuilderComponentTypes.PreviousSchoolEmail,
        description: 'Previous School Email',
        category: ComponentCategory.STUDENT_PROFILE_ATTRIBUTES
    },
    {
        type: FormBuilderComponentTypes.EmployeeSelect,
        description: 'Employee Select',
        category: ComponentCategory.CHOICE
    },
    {
        type: FormBuilderComponentTypes.StudentPhoto,
        description: 'Student Photo',
        category: ComponentCategory.STUDENT_PROFILE_ATTRIBUTES
    },
];